<template>
  <transition-group
    tag="div"
    mode="out-in"
    name="list-fade"
    style="position: relative"
  >
    <!-- Existing ones -->
    <QueuedUpload
      v-for="(upload, index) in values"
      :key="upload.$key || upload.path"
      :class="uploadClass"
      :style="uploadStyle"
      :value="upload"
      :disabled="disabled"
      class="list-fade"
      @upload="updateUploadAtIndex(index, $event)"
      @uploaded="$emit('uploaded', $event)"
      @selected="$emit('selected', $event)"
      @remove="removeUploadAtIndex(index)"
    />

    <div
      v-if="disabled && values && values.length == 0"
      key="notFound"
      class="tenda-expired--text"
    >
      Nenhum arquivo encontrado
    </div>

    <!-- Add new one -->
    <QueuedUpload
      v-show="canUploadMore && !disabled"
      ref="queuedUpload"
      :key="`new-upload:${values && values.length}`"
      :style="uploadStyle"
      :disabled="disabled"
      :file-selected="fileSelected"
      class="list-fade"
      @upload="createUpload($event)"
      @uploaded="$emit('uploaded', $event)"
      @selected="$emit('selected', $event)"
    />
  </transition-group>
</template>

<script>
import QueuedUpload from "@/components/QueuedUpload";

export default {
  name: "QueuedUploadList",

  components: {
    QueuedUpload,
  },

  model: {
    prop: "values",
    event: "change",
  },

  props: {
    values: {
      type: Array,
      default: () => [],
    },

    limit: {
      type: Number,
      default: 2,
    },

    onChange: {
      type: Function,
    },

    uploadStyle: {},

    uploadClass: {},

    persistent: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    fileSelected: {
      type: Function,
    },

    // groupKey: {
    //   type: String,
    //   default: null,
    // }
  },

  data: function () {
    return {
      uploading: [],
    };
  },

  computed: {
    canUploadMore() {
      if (this.values && this.uploading) {
        return this.values.length + this.uploading.length < this.limit;
      }

      return false;
    },
  },

  created() {
    if (this.values == null) {
      //this.values = []
    }
  },

  methods: {
    updateUploadAtIndex(index, model) {
      // this.values = this.values.map(test => test)
      // newValues[index] = model
      this.$set(this.values, index, model);
      this.$emit("change", this.values);
    },

    removeUploadAtIndex(index) {
      this.values.splice(index, 1);
      this.$emit("change", this.values);
    },

    createUpload(model) {
      this.values.push(model);
      this.$emit("upload", model);
      this.$emit("change", this.values);
    },

    onUploadFinished() {},

    openUpload() {
      this.$refs.queuedUpload && this.$refs.queuedUpload.openUpload();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/QueuedUploadList.vue